import React from "react";
import {Navigate, useParams} from 'react-router-dom';
// import axios from 'axios';
import Menu from "../components/menu/Menu";
import TableInvitados from "../components/invitados/Invitados";
import {Container} from 'react-bootstrap';
import Verify from "../components/verify/Verify"
// import { trackPromise } from 'react-promise-tracker';

const Invitados = () => {

    const params = useParams();
    var idevento = null;
    
    if(params){
        idevento = params.idevento
       
    }

    if(!sessionStorage.getItem('userData')){
        return <Navigate to="/"  />;
    }
    else{
        Verify()
    }
    

    let ud = sessionStorage.getItem('userData');
    let userData = JSON.parse(ud);

    if(userData.jerarquia === 2){
        return(
            <>
                <Menu />
                <Container fuild>
                    <TableInvitados id={idevento} />
                </Container>
            </>
        )
    }
    else{
        return(<>
            <Menu />
            <Container fluid>
               <h1 className="mt-4">No tiene permiso para ver este recurso</h1>
            </Container>
       </>)
    }
};

export default Invitados;
